module.exports = __webpack_public_path__ + "static/media/leonardo_balerdi.0ad30711.jpg";